// import React, { useEffect, useState } from 'react';

import ModalAssociaRoleCpf from "../componentes/ModalAssociaRoleCpf";
import TituloSessao from "../componentes/TituloSessao";

function ConfiguracoesGerais() {

    return (
        <div className="container-fluid">
            <TituloSessao titulo="Configuração CPF x Permissão" barraDecorativa={false} tituloAlignStart={false} />
                <ModalAssociaRoleCpf/>
            {/* <TituloSessao titulo="Atualizar view Indicadores Alcançados e Inalcançados Por Métrica" barraDecorativa={false} tituloAlignStart={false} />
            <div className="d-flex justify-content-center mt-3">
                <button className='btn btn-primary' type='submit'>Atualizar</button>
            </div>
            <TituloSessao titulo="Atualizar view Indicadores Mensais Por Métrica " barraDecorativa={false} tituloAlignStart={false} />
            <div className="d-flex justify-content-center mt-3">
                <button className='btn btn-primary' type='submit'>Atualizar</button>
            </div> */}
        </div>
    );
}

export default ConfiguracoesGerais